
/**
 * We store simulation constants for our simulation library here.
 */

export const noiseSources = {
    r1: "r1",
    r2: "r2",
    r3: "r3",
    r4: "r4",
    r5: "r5",
    r6: "r6",
    r7: "r7",
    r8: "r8",
    opAmpVoltage: "OpAmpVoltage",
    opAmpNegCurrent: "OpAmpNegCurrent",
    opAmpPosCurrent: "OpAmpPosCurrent",

    differentialAmpVoltage: "DifferentialAmpVoltage",
    differentialAmpNegCurrent: "DifferentialAmpNegCurrent",
    differentialAmpPosCurrent: "DifferentialAmpPosCurrent",
    differentialAmpVocm: "DifferentialAmpVocm",
};

//Noise of 1k resistor at 27 degrees C (300.15 K)
//We use 27 degrees because that's what LTspice uses (TNOM)
export const resistorNoiseBase = 4.07137e-9;

export const Limits = {
    PARASITIC_INPUT_CAP: 3e-12
};

// When cascading y-parameter blocks, too-small series resistance leads to computational errors.  
// To avoid errors, We have been using 1e-3 for most series resistances.
// TODO: replace all instances of small series resistors in our models with this constant and see how small we can make the value before unaccepatble computational errors occur
export const MIN_SERIES_RESISTANCE = 1e-3;

export const transferFunctionType = {
    r1: 'r1',
    r2: 'r2',
    r3: 'r3',
    r4: 'r4',
    r5: 'r5',
    r6: 'r6',
    r7: 'r7',
    r8: 'r8',
    ref: 'ref',
    vIn: 'vIn',
    vInPositivePath: 'vInPositivePath',
    vInNegativePath: 'vInNegativePath',
    opAmpNegINoise: 'opAmpNegINoise',
    opAmpPosINoise: 'opAmpPosINoise',
    opAmpVNoise: 'opAmpVNoise',

    differentialAmpNegINoise: 'differentialAmpNegINoise',
    differentialAmpPosINoise: 'differentialAmpPosINoise',
    differentialAmpVNoise: 'differentialAmpVNoise',
    differentialAmpVocmNoise: 'differentialAmpVocmNoise',
    vOcm: 'vOcm',
    vOutPositive: 'vOutPositive',
    vOutNegative: 'vOutNegative'
};

export const outputVoltageType = {
    vOut: 'vOut',
    vOutPositive: 'vOutPositive',
    vOutNegative: 'vOutNegative',
    vOutDifferential: 'vOutDifferential',
    vOutCommonMode: 'vOutCommonMode',
    currentIntoGroundedVOutPositive: 'currentIntoGroundedVOutPositive',
    currentIntoGroundedVOutNegative: 'currentIntoGroundedVOutNegative',
};

    //             levelShift:'r5 Ground, r6 Reference'  commonModePin:'Reference with r7 & r8' 1: R5 to GND, R6 to VREF, voltage divider between VREF and VOCM
    //             levelShift:'r5 Reference, r6 Ground'  commonModePin:'Reference with r7 & r8' 2: R5 to VREF, R6 to GND, voltage divider between VREF and VOCM         
    //             levelShift:'None'                     commonModePin:'Reference with r7 & r8' 3: No R5, R6, voltage divider between VREF and VOCM         
    //             levelShift:'r5 Ground, r6 Reference'  commonModePin:'Ground'                 4: R5 to GND, R6 to VREF, NO voltage divider between VREF and VOCM        
    //             levelShift:'r5 Reference, r6 Ground'  commonModePin:'Ground'                 5: R5 to VREF, R6 to GND, NO voltage divider between VREF and VOCM        
    //             levelShift:'None'                     commonModePin:'Ground'                 6: No R5, R6, NO voltage divider between VREF and VOCM  (VREF directly tied to VOCM)      

export let configurationType = {
    r5Groundr6Reference: 'r5 Ground, r6 Reference',
    r5Referencer6Ground: 'r5 Reference, r6 Ground',
    none: 'None',
    ground: 'Ground',
    reference: 'Reference',
    referencer7r8: 'Reference with r7 & r8',
    negativeDifferential: 'Negative Differential',
    positiveDifferential: 'Positive Differential',
    negativeSingleEnded: 'Negative Single Ended',
    positiveSingleEnded: 'Positive Single Ended',
    // polarity and IO_TYPE should eventually replace above, since they are independent properties
    polarity: {
        positive: 'positive',
        negative: 'negative'
    }
};

export const REFERENCE_CONFIG = {
    NONE : 'None',
    FLOATING: 'Floating',
    GROUND : 'Ground',
    REFERENCE_ONLY: 'Reference Only',
    DIVIDER : 'Divider',
    RC_FILTER : 'RC Filter',
    BUFFERED_RC_FILTER: 'Buffered RC Filter',
    BUFFER : 'Buffer',
    BUFFERED_DIVIDER: 'Buffered Divider',
    NONINVERTING : 'Noninverting',
    INVERTING : 'Inverting',
    REFERENCE_AND_INVERTING: 'Reference and Inverting'
}

export const AMP_CONFIG = {
    // Available positive circuits
    BUFFERED_DIVIDER: 'Buffered Divider',
    DIVIDER: "Divider",
    BUFFER:  "Buffer",
    NONINVERTING:  "Noninverting",
    NONINVERTING_OFFSET_2_RESISTOR:  "Noninverting 2 Resistor with Offset",
    NONINVERTING_OFFSET_3_RESISTOR:  "Noninverting 3 Resistor with Offset",
    DIVIDER_OFFSET_2_RESISTOR:  "2 Resistor Divider with Offset",
    DIVIDER_OFFSET_3_RESISTOR:  "3 Resistor Divider with Offset",
    NONINVERTING_DIVIDER_OFFSET:  "Noninverting Divider with Offset",
    // Available negative circuits
    INVERTING: "Inverting",
    INVERTING_OFFSET_4_RESISTOR:  "Inverting 4 Resistor with Offset",
    INVERTING_OFFSET_2_RESISTOR:  "Inverting 2 Resistor with Offset"    ,
};

export const IO_TYPE = {
    SINGLE_ENDED_VOLTAGE: "Single Ended Voltage",
    DIFFERENTIAL_VOLTAGE: "Differential Voltage",
    SINGLE_ENDED_CURRENT: "Single Ended Current",
    DIFFERENTIAL_CURRENT: "Differential Current",
    SINGLE_ENDED_IMPEDANCE: "Single Ended Impedance",
    DIFFERENTIAL_IMPEDANCE: "Differential Impedance",
    GENERIC_ADMITTANCE: "Generic Admittance"
}

export const SENSOR_TYPE = {
    VOLTAGE_SENSOR: 'Voltage Sensor',
    CURRENT_SENSOR: 'Current Sensor',
    BRIDGE_SENSOR:  'Bridge Sensor',
    PHOTODIODE:     'Photodiode'
}

export const INPUT_PROTECTION_TYPE = {
    VARISTOR : 'Varistor',
    BACK_TO_BACK : 'Back to Back',
    STACKED : 'Stacked'
}

export const POWER_SUPPLIES = {
    POS : 'vsP',
    NEG : 'vsN',
}

export const ADC_PIN_LIMITERS = {
    GND : 'GND',
    REF : 'VREF',
    AVDD : 'AVDD',
    AVSS : 'AVSS',
    AVDD5 : 'AVDD5',
    AVDD1 : 'AVDD1',
}

const COMMON_PIN_NAMES = {
    INPUT_POS: 'Input+',
    INPUT_NEG: 'Input-',
    OUTPUT: 'Output',
    OUTPUT_POS: 'Output+',
    OUTPUT_NEG: 'Output-',
    OUTPUT_CM : 'OutputCM',
    VOCM: 'Vocm',
    REF : 'Ref',
    SUPPLY_POS: 'vsP',
    SUPPLY_NEG: 'vsN'
}
export const PIN_NAMES = {
    COMMON: COMMON_PIN_NAMES,
    OP_AMP : {
        INPUT_POS   : COMMON_PIN_NAMES.INPUT_POS,
        INPUT_NEG   : COMMON_PIN_NAMES.INPUT_NEG,
        OUTPUT      : COMMON_PIN_NAMES.OUTPUT,
        SUPPLY_POS  : COMMON_PIN_NAMES.SUPPLY_POS,
        SUPPLY_NEG  : COMMON_PIN_NAMES.SUPPLY_NEG,
    }, 
    DIFF_AMP : {
        INPUT_POS   : COMMON_PIN_NAMES.INPUT_POS,
        INPUT_NEG   : COMMON_PIN_NAMES.INPUT_NEG,
        OUTPUT_POS  : COMMON_PIN_NAMES.OUTPUT_POS,
        OUTPUT_NEG  : COMMON_PIN_NAMES.OUTPUT_NEG,
        OUTPUT_CM   : COMMON_PIN_NAMES.OUTPUT_CM,
        VOCM        : COMMON_PIN_NAMES.VOCM,
        SUPPLY_POS  : COMMON_PIN_NAMES.SUPPLY_POS,
        SUPPLY_NEG  : COMMON_PIN_NAMES.SUPPLY_NEG,
        SUPPLY_INPUT_POS  : 'Input ' + COMMON_PIN_NAMES.SUPPLY_POS,
        SUPPLY_INPUT_NEG  : 'Input ' + COMMON_PIN_NAMES.SUPPLY_NEG,
    },
    IN_AMP : {
        INPUT_POS   : COMMON_PIN_NAMES.INPUT_POS,
        INPUT_NEG   : COMMON_PIN_NAMES.INPUT_NEG,
        OUTPUT      : COMMON_PIN_NAMES.OUTPUT,
        OUTPUT_POS  : COMMON_PIN_NAMES.OUTPUT_POS,
        OUTPUT_NEG  : COMMON_PIN_NAMES.OUTPUT_NEG,
        PRE_AMP_OUT_POS : 'Pre-Amp ' + COMMON_PIN_NAMES.OUTPUT_POS,
        PRE_AMP_OUT_NEG : 'Pre-Amp ' + COMMON_PIN_NAMES.OUTPUT_NEG,
        DIFF_AMP_IN_POS:  'Diff-Amp In+', 
        DIFF_AMP_IN_NEG:  'Diff-Amp In-', 
        REF         : COMMON_PIN_NAMES.REF,
        VOCM        : COMMON_PIN_NAMES.VOCM,
        SUPPLY_POS  : COMMON_PIN_NAMES.SUPPLY_POS,
        SUPPLY_NEG  : COMMON_PIN_NAMES.SUPPLY_NEG,
        SUPPLY_INPUT_POS  : 'Input ' + COMMON_PIN_NAMES.SUPPLY_POS,
        SUPPLY_INPUT_NEG  : 'Input ' + COMMON_PIN_NAMES.SUPPLY_NEG,
        SUPPLY_DIGITAL_POS: 'DVDD',
        SUPPLY_DIGITAL_NEG: 'DVSS',
        SUPPLY_CP_POS : 'CP ' + COMMON_PIN_NAMES.SUPPLY_POS,
    },
    ADC : {
        INPUT_POS   : COMMON_PIN_NAMES.INPUT_POS,
        INPUT_NEG   : COMMON_PIN_NAMES.INPUT_NEG,
        DIFF_INPUT     : 'Input',
        CM_INPUT     : 'InputCM',
        SUPPLY_POS  : COMMON_PIN_NAMES.SUPPLY_POS,
        SUPPLY_NEG  : COMMON_PIN_NAMES.SUPPLY_NEG,
        DRIVER_SUPPLY_POS : 'Driver ' + COMMON_PIN_NAMES.SUPPLY_POS,
        DRIVER_SUPPLY_NEG : 'Driver ' + COMMON_PIN_NAMES.SUPPLY_NEG,
        FILTER_SUPPLY_POS : 'Filter ' + COMMON_PIN_NAMES.SUPPLY_POS,
        FILTER_SUPPLY_NEG : 'Filter ' + COMMON_PIN_NAMES.SUPPLY_NEG,
    },
    REF : {
        OUTPUT      : COMMON_PIN_NAMES.OUTPUT,
        SUPPLY_POS  : COMMON_PIN_NAMES.SUPPLY_POS,
        SUPPLY_NEG  : COMMON_PIN_NAMES.SUPPLY_NEG,
    },
    DIODE : {
        OUTPUT      : COMMON_PIN_NAMES.OUTPUT,
        SUPPLY_POS  : COMMON_PIN_NAMES.SUPPLY_POS,
        SUPPLY_NEG  : COMMON_PIN_NAMES.SUPPLY_NEG,
    },
    POWER_SUPPLY : {
        OUTPUT      : COMMON_PIN_NAMES.OUTPUT,
    }
}

export const COMPONENT_NAMES = {
    OP_AMP   : 'opAmp',
    IN_AMP   : 'inAmp',
    DIFF_AMP : 'differentialAmp',
    ADC      : 'adc',
    DRIVER   : 'driver',
    REFERENCE: 'reference',
    REF_BUF  : 'referenceBuffer',
    DIODE    : 'd',
    // POWER_SUPPLIES : 'powerSupplies'
}

export const ALTERNATE_NAMES = {
    'ref' : COMPONENT_NAMES.REFERENCE,
    'refBuf' : COMPONENT_NAMES.REF_BUF,
    [COMPONENT_NAMES.REFERENCE] : 'ref',
    [COMPONENT_NAMES.REF_BUF] : 'refBuf',
}

export const AMBIENT_UPPER = 85;
export const AMBIENT_LOWER = 25;
export const DC_ERROR_ABBREVIATIONS = {
  OP_AMP: {
    OFFSET: "Vos",
    OFFSET_DRIFT: "VosTC",
    BIAS_CURRENT: "Ibias",
    BIAS_CURRENT_DRIFT: "IbiasTC",
    OFFSET_CURRENT: "Ios",
    OFFSET_CURRENT_DRIFT: "IosTC",
    OPEN_LOOP_GAIN: "Aol",
    CMRR: "CMRR",
  },
  IN_AMP: {
    OFFSET: "Vos",
    OFFSET_DRIFT: "VosTC",
    BIAS_CURRENT: "Ibias",
    BIAS_CURRENT_DRIFT: "IbiasTC",
    OFFSET_CURRENT: "Ios",
    OFFSET_CURRENT_DRIFT: "IosTC",
    GAIN_ERROR: "GainError",
    GAIN_DRIFT: "GainTC",
    CMRR: "CMRR",
  },
  DIFF_AMP: {
    OFFSET: "Vos",
    OFFSET_DRIFT: "VosTC",
    BIAS_CURRENT: "Ibias",
    BIAS_CURRENT_DRIFT: "IbiasTC",
    OFFSET_CURRENT: "Ios",
    OFFSET_CURRENT_DRIFT: "IosTC",
    GAIN_ERROR: "GainError",
    GAIN_DRIFT: "GainTC",
    CMRR: "CMRR",
    CMRR_DRIFT: "CMRRTC",
  },
  REFERENCE: {
    INITIAL_ACCURACY: "InitAcc",
    DRIFT: "InitAccTC",
    LOAD_REGULATION: "LoadReg",
  },
  ADC: {
    ZERO_ERROR: "ZeroError",
    ZERO_ERROR_DRIFT: "ZeroTC",
    GAIN_ERROR: "GainError",
    GAIN_DRIFT: "GainTC",
    INPUT_CURRENT: "Ibias",
    OFFSET_CURRENT: "Ios",
    OFFSET_CURRENT_DRIFT: "IosTC",
    INL: "INL",
    VREF_ERROR: "RefInitAcc",
    VREF_DRIFT: "RefInitAccTC",
    REF_INPUT_CURRENT: "RefInIbias",
    REF_INPUT_CURRENT_DRIFT: "RefInIbiasTC",
    REF_BUFFER_OFFSET: "RefInVos",
    REF_BUFFER_DRIFT: "RefInTC",
  },
  DIODE: {
    LEAKAGE: "ILeakage",
    LEAKAGE_DRIFT: "ILeakageTC"
  }  
};

export const SYSTEMIC_ERRORS = {
    AOL: 'Aol',
    DRIVE_IMPEDANCE: 'Drive Impedance',
    SOURCE_IMPEDANCE: 'Source Impedance',
    IC_INPUT_IMPEDANCE: 'IC Input Impedance',
    RESISTOR_ROUNDING: 'Standard Resistor Rounding',
}

export const DC_ERROR_SENSITIVITY_MINIMUM = 1e-6;

export const DEFAULT_SUPPLY_TOLERANCE = {
    INPUT_RANGE_SIM : 'typ',
    POWER_SIM : 'typ',
}

export const HELP_TEXT_ICON = {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
}

export const DC_ERROR_DIALOG = {
    COARSE: "coarse",
    MISSING: "missing",
    GENERIC_WARNING: "genericWarning",
    INFO: "info"
}

export const INPUT_RANGE_VIOLATIONS = {
    SIGNAL_EXCEEDS_LIMIT : 'Signal Exceeds Limit',
    NO_LIMITS : 'No Limits Specified',
    INFINITE_INPUT_RANGE : 'Infinite Input Range',
    DC_OPERATING_POINT : 'DC Operating Point',
    NO_SIGNAL_RANGE : 'No Signal Range',
    SIGNAL_RANGE_INCOMPATIBILITY : 'Signal Range Incompatibility',
    ADC_RANGE_NOT_OPTIMIZED : 'ADC Input Range Not Optimized',
    ADC_INPUT_CM_ERROR: 'ADC Input CM Range Error',
    SUPPLY_NOT_CONNECTED : 'Supply Pin Not Connected',
    SUPPLY_NOT_FOUND : 'Power Supply Not Found',
    VOCM_OUT_OF_RANGE : 'Vocm Pin Out of Range',
    DIFF_AMP_OCM_ERROR: 'Output CM Out of Range',
    OVERCURRENT_1 : 'Overcurrent 1',
    OVERCURRENT_2 : 'Overcurrent 2',
    OVERVOLTAGE_1 : 'Overvoltage 1',
    OVERVOLTAGE_2 : 'Overvoltage 2',
}

export const POWER_TYPE = {
    QUIESCENT : 'quiescent',
    SIGNAL    : 'signal',
    // SAMPLE_RATE_DEPENDENT : 'quiescent'
    SAMPLE_RATE_DEPENDENT : 'sample-rate dependent'
}

export const POWER_SIM_MIN_REPORTED_CURRENT = 0.1e-6;
export const POWER_SIM_MIN_REPORTED_POWER   = 0.1e-6;

// Allow amplifier inputs to go past headroom spec by x amount since input limits are typically "soft" and will report violations when right at the limit, where the amplifier is still functional
export const AMP_INPUT_ADDITIONAL_HEADROOM = 10e-3;

// Reference pin on in-amps is a resistor with ESD diodes to the supplies.  The voltage on the REF pin can go beyond the supplies by some amount before engaging the ESD diodes
export const IN_AMP_REF_PIN_HEADROOM = -10e-3;